// extracted by mini-css-extract-plugin
export var filterIncDec = "_9r-0";
export var leftBorder = "_9r-1";
export var rightBorder = "_9r-2";
export var stringInput = "_9r-3";